import { testStageBaseUrls as baseUrls } from 'src/environments/base-urls';

export { testStageBaseUrls as baseUrls } from 'src/environments/base-urls';

export const environment = {
  production: false,
  TAG_MANAGER_CONTAINER_ID: 'GTM-MMTK3JH',
  TAG_MANAGER_AUTH: 'Ry3lxk_Xrlx2qhbXmLA-Pg',
  TAG_MANAGER_ENV: 'env-254',
  ENV_NAME: 'STAGE',
  HUBSPOT_ACCOUNT: '2939619',
  STRIPE_API_KEY:
    'pk_test_42OEjvquXu8LSM9TiyEBtSrm1X2o2X9OPn5toIXy4s6rZJBlVPE2a22fQtXfSGX5jxT66Une31cDMDVK8Zsq3dG0d00CwmoWu5Z',
  PIXABAY_API_KEY: '42941787-c47b7eb6f834a8cdbc497637d',
  CORE_URL: baseUrls.CORE_BASE_URL + '/_ah/api',
  STORE_SERVER_URL: baseUrls.STORE_BASE_URL + '/',
  VIEWER_URL: baseUrls.VIEWER_BASE_URL,
  SHARED_SCHEDULE_URL:
    baseUrls.VIEWER_BASE_URL + '/?type=sharedschedule&id=SCHEDULE_ID',
  ALERTS_WS_URL: baseUrls.CORE_BASE_URL + '/alerts/cap',
  SCREEN_SHARING_SERVICE_URL:
    'wss://' + baseUrls.SERVICES2_BASE_DOMAIN + '/screensharing/',
  SCREEN_SHARING_API_URL:
    'https://' + baseUrls.SERVICES2_BASE_DOMAIN + '/screensharing/',
  MESSAGING_PRIMUS_URL:
    baseUrls.SERVICES_BASE_URL + '/messaging/primus?displayId=apps&machineId=1',
  HTML_TEMPLATE_URL: baseUrls.TEMPLATES_BASE_URL + '/src/template.html',
  SSO_LOGIN_URL: baseUrls.CORE_BASE_URL + '/sso/login',
  SPRING_ENDPOINT_URL: baseUrls.CORE_BASE_URL + '/api/core',
  SPRING_STORAGE_ENDPOINT_URL: baseUrls.STORAGE_BASE_URL + '/api/storage',
  SPRING_STORE_ENDPOINT_URL: baseUrls.STORE_BASE_URL + '/api/store',
  AI_SERVICE_URL: 'https://' + baseUrls.SERVICES2_BASE_DOMAIN + '/ai-service',
  AI_SERVICE_API_KEY: '#kwXjiteKMo$72',
  CHARGEBEE: 'V2',
};
